import { purchase } from 'js-api-client';

const REQUEST_TIMEOUT = 1500;

/** Bound lookup requests, including stalled response bodies. */
export function lookupReferralLink(slug, signal) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  if (signal?.aborted) controller.abort();
  let timer;
  const timeout = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      controller.abort();
      reject(new Error('Referral request timed out'));
    }, REQUEST_TIMEOUT);
  });
  const response = Promise.resolve().then(() => {
    return purchase.lookupReferralLink(slug, controller.signal);
  });
  return Promise.race([response, timeout]).finally(() => {
    clearTimeout(timer);
    signal?.removeEventListener('abort', abort);
  });
}

/** Keep best-effort visit failures nonblocking, without retrying throttled requests. */
export function registerReferralVisit(slug, visitId) {
  return Promise.resolve()
    .then(() => purchase.registerReferralVisit(slug, visitId))
    .catch(() => null);
}
